export const FETCH_SMS_TEMPLATES = 'FETCH_SMS_TEMPLATES'
export const FETCH_SMS_BALANCE = 'FETCH_SMS_BALANCE'